// extracted by mini-css-extract-plugin
module.exports = {"wrapText":"ContactMe_wrapText__2BFWU","cs":"ContactMe_cs__2Idtf","parent":"ContactMe_parent__Khf6Q"};